import { ackVideoPlayStart } from '@/actions';
import { BASE_URL } from '@/actions/API';
import React, { useRef, useState } from 'react';

const VideoEmbed = ({ video, isUser }) => {
  const videoRef = useRef(null);
  const videoUrl = BASE_URL.replace('/api', '') + video.url;
  const hasCalledAck = useRef(false);
  const [showControls, setShowControls] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setShowControls(true);
      setIsPlaying(true);
    }
  };

  const handlePlay = () => {
    if (!hasCalledAck.current) {
      if (isUser) ackVideoPlayStart(video.uuid);

      hasCalledAck.current = true;
    }
    setIsPlaying(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
    setShowControls(false);
  };

  const handleContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  const handleDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  const handleSelectStart = (e) => {
    e.preventDefault();
    return false;
  };

  return (
    <div
      className="w-full rounded-lg absolute top-0 left-0 aspect-video h-full select-none group"
      aria-hidden={false}
      onContextMenu={handleContextMenu}
      onDragStart={handleDragStart}
      onSelectStart={handleSelectStart}>
      <video
        ref={videoRef}
        src={videoUrl}
        preload="metadata"
        // poster="https://img.youtube.com/vi/K-66nveAL7g/0.jpg"
        controls={showControls}
        controlsList="nodownload"
        disablePictureInPicture
        className="w-full h-full object-cover object-center rounded-lg select-none"
        onPlay={handlePlay}
        onPause={handlePause}
        onContextMenu={handleContextMenu}
        onDragStart={handleDragStart}
      />

      {!isPlaying && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 rounded-lg cursor-pointer transition-all duration-300 hover:bg-opacity-40"
          onClick={handlePlayClick}
          onContextMenu={handleContextMenu}>
          <div className="relative">
            <div
              className="absolute inset-0 rounded-full bg-white bg-opacity-20 animate-ping"
              style={{
                animationDuration: '2s',
                transform: 'scale(0.85)',
                transformOrigin: 'center',
              }}
            />
            <div className="relative w-20 h-20 md:w-16 md:h-16 bg-white bg-opacity-90 rounded-full flex items-center justify-center shadow-2xl transform transition-all duration-300 hover:scale-110 hover:bg-opacity-100">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-gray-900">
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoEmbed;
